<template>
  <div>
    <router-link
      :to="{ name: 'BlogpostSingle', params: { id: blogpost.slug }}"
      class="blogpost-card"
    >
      <div class="blogpost-image">
        <b-img :src="blogpost.featured_image.url" :alt="blogpost.title"/>
      </div>
      <div class="blogpost-content">
        <span class="time">{{ blogpost.published_at }}</span>
        <h4 v-html="blogpost.title"></h4>
        <p class="preview-content" v-html="blogpost.preview_content"></p>

        <div
          class="comments-count"
          v-if="blogpost.responses_count"
        >{{blogpost.responses_count}} comentários</div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "BlogpostCard",
  props: {
    blogpost: Object
  }
};
</script>

<style scoped lang="sass">
.blogpost-card
  width: 100%
  height: 400px
  display: block
  margin: 0 0 5px
  background: rgba(0, 0, 0, .1)
  transition: all .2s
  // position: relative;
  border-radius: 4px
  opacity: .5

  &:hover
    color: black
    text-decoration: none
    opacity: 1
    .blogpost-image
      img
        transform: scale(1.2)

    .blogpost-content
      h4
        color: rgba(255, 255, 255, 1)
      p.preview-content
        color: rgba(255, 255, 255, 1)
      span.time
        color: rgba(255, 255, 255, .6)
    background: rgba(255, 255, 255, .05)
      
  .blogpost-image
    width: 100%
    height: 180px
    overflow: hidden
    border-top-left-radius: 4px
    border-top-right-radius: 4px
    img
      width: auto
      height: 100%
      object-fit: cover
      transition: all .2s
      border-top-left-radius: 4px
      border-top-right-radius: 4px
    
  .blogpost-content 
    width: 100%
    height: 140px
    padding: 20px
    // color: #999

    span.time
      font-size: 13px
      font-style: italic
      color: rgba(255, 255, 255, .3)

    h4
      font-weight: bold
      margin-bottom: 5px
      color: rgba(255, 255, 255, .7)
      // color: #fff
      transition: all .2s

    p.preview-content
      font-size: 13px
      color: rgba(255, 255, 255, .7)
      // color: #eee
    
    .comments-count
      font-size: 13px
      color: rgba(255, 255, 255, .3)
      // font-weight: bold

</style>
